<template>
  <div id="app">
    <router-view />
    <PortalTarget name="modal" />
    <Dialog v-if="error.messages.length" :message="error.messages.join('\n')" @close="close" />
    <PortalTarget name="loading" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { PortalTarget } from 'portal-vue'
import Dialog from '@/components/molecules/Dialog'

export default {
  name: 'App',
  components: {
    PortalTarget,
    Dialog,
  },
  computed: {
    ...mapState({
      error: state => state.error,
    }),
  },
  watch: {
    '$i18n.locale'(lang) {
      document.querySelector('html').setAttribute('lang', lang)
    },
  },
  created() {
    document.querySelector('html').setAttribute('lang', this.$i18n.locale)
  },
  methods: {
    close() {
      this.$store.commit('error/message')
    },
  },
}
</script>
